export default {
    header: {
        telefone: "Telefon",
        signIn: "Anmelden",
        register: "Registrieren",
        becomeExpert: "Ihr Unternehmen registrieren",
        dashboard: "Dashboard",

        sidebar: {
            tuktuk: {
                title: "Tuk Tuk",
                subtitle: "Tuk Tuk Buchung",
                menu: {
                    grid: "Tuk Tuk Auflistung",
                },
            },
            about: {
                title: "Über",
                subtitle: "Über",
                menu: {
                    aboutUs: "Über Uns",
                    testimonials: "Referenzen",
                    faq: "Häufig gestellte Fragen",
                    contact: "Kontakt",
                    terms: "Allgemeine Geschäftsbedingungen",
                    privacy: "Datenschutzbestimmungen",
                },
            },
            dashboard: {
                title: "Dashboard",
                subtitle: "Benutzer-Dashboard",
                subtitle2: "Agenten-Dashboard",
                menu: {
                    dashboard: "Dashboard",
                    myBookings: "Meine Buchungen",
                    reviews: "Bewertungen",
                    support: "Support",
                    wishlist: "Wunschliste",
                    wallet: "Brieftasche",
                    profileSettings: "Profileinstellungen",
                    notifications: "Benachrichtigungen",
                    myProfile: "Mein Profil",
                    settings: "Einstellungen",
                    dashboard2: "Dashboard",
                    bookings: "Buchungen",
                    enquiries: "Anfragen",
                    earnings: "Einnahmen",
                    reviews2: "Bewertungen",
                    settings2: "Einstellungen",
                },
            },
            social: {
                title: "Soziales Netzwerk",
                subtitle: "Beitrags-Feed",
                menu: {
                    feed: "Feed",
                    myProfilePage: "Meine Profilseite",
                    explore: "Entdecken",
                },
            },
        },
    },

    common: {
        welcome: "Willkommen, {{name}}!",
    },

    home: {
        hero: {
            title: "Dem Traum näherkommen:",
            title2: "Ihre Reiseutensilien warten auf",
            title3: "Sie",
            subtitle: "Ihr ultimatives Ziel für alles, was dazu beiträgt, Ihr Reiseerlebnis zu feiern und in Erinnerung zu behalten.",
            tukTuk: "Tuk Tuk",
        },
        searchBy: {
            titlePrefix: "Neueste",
            titleSuffix: "Pakete",
            subtitle:
                "Entdecken Sie die neuesten Pakete, die zu Portugalwaytour hinzugefügt wurden, und erkunden Sie einzigartige Reisemöglichkeiten, die sorgfältig ausgewählt wurden, um Ihnen unvergessliche Erlebnisse, neue Reiseziele und exklusive Abenteuer auf der ganzen Welt zu bieten.",
            noPackages: "Keine neuen Pakete gefunden.",
            hasDiferencial: "Hat einen Unterschied",
            noReviews: "Keine Bewertungen",
            viewAll: "Alle Pakete ansehen",
        },
        sectionBenefit: {
            titlePrefix: "Unsere",
            titleHighlight: "Vorteile",
            titleSuffix: "und Hauptvorteile",
            subtitle:
                "Portugalway, ein auf Traumziele spezialisierter Reiseveranstalter, bietet Reisenden eine Vielzahl von Vorteilen.",
            benefits: [
                {
                    title: "Authentische Erlebnisse",
                    description:
                        "Entfliehen Sie dem traditionellen Tourismus und entdecken Sie das authentische Portugal! Unsere Touren bieten echte Erlebnisse, bei denen Sie die lokale Kultur, Küche und geheime Orte erkunden.",
                },
                {
                    title: "Personalisierte Reisepakete",
                    description:
                        "Gestalten Sie Ihre maßgeschneiderte Reise! Wählen Sie Ihr Erlebnis und wir kümmern uns um alles: Unterkunft, Transport und Aktivitäten für eine personalisierte und unvergessliche Reise.",
                },
                {
                    title: "Komfort und Sicherheit",
                    description:
                        "Wir kümmern uns um alle Details: bequemer Transport, ausgewählte Unterkünfte und Begleitung durch professionelle Guides, die Ihnen von Anfang bis Ende der Reise Sorgenfreiheit garantieren.",
                },
                {
                    title: "Engagierter Kundenservice",
                    description:
                        "Vom ersten Kontakt bis zur Rückkehr Ihrer Reise erhalten Sie persönliche Unterstützung und ein Team, das bereit ist, Ihnen auf Portugiesisch und Englisch schnell und mit voller Aufmerksamkeit für Ihre Bedürfnisse zu dienen.",
                },
            ],
        },
        exploreCities: {
            title: "Nach Stadt erkunden",
            subtitle: "Entdecken Sie einzigartige Erlebnisse an unglaublichen Reisezielen",
        },
        placeSection: {
            titlePrefix: "Trendige",
            titleHighlight: "Pakete",
            subtitle:
                "Entdecken Sie unsere beliebtesten Reisepakete, die sorgfältig aufgrund ihrer hohen Bewertungen, positiven Rezensionen und häufigen Buchungen durch andere Reisende ausgewählt wurden. Finden Sie hier Ihr nächstes unvergessliches Abenteuer.",
            all: "Alle",
            hasDiferencial: "Hat einen Unterschied",
            noReviews: "Keine Bewertungen",
            viewAll: "Alle Pakete ansehen",
        },
        aboutSection: {
            welcome: "Willkommen bei Portugalwaytour",
            title: "Über den Horizont hinaus erkunden: Entdecken Sie die Wunder der Welt",
            description1: "Bei Portugal Way Tour glauben wir, dass Reisen Transformation ist. Wir sind eine auf einzigartige touristische Erlebnisse in Portugal spezialisierte Agentur, die sich verpflichtet hat, das Beste des Landes – seine Kultur, Landschaften, Geschichte und Authentizität – zu enthüllen.",
            point1: "Unvergessliche Reisen mit Komfort, Sicherheit und Charme zu ermöglichen. Wir möchten, dass jeder Tourist Portugal auf tiefgreifende Weise entdeckt, mit Reiserouten, die Tradition, Natur, Gastronomie und echte Gastfreundschaft vereinen.",
            point2: "Eine Referenz für Qualität und Vertrauen im Tourismus in Portugal zu sein, anerkannt von Touristen aus aller Welt als Synonym für Professionalität und Verzauberung.",
            learnMore: "Mehr erfahren",
            reviews: "{{count}}+ Bewertungen"
        },
        aboutCounters: [
            { label: "Reiseziele weltweit", icon: "isax-global5", colorClass: "text-teal" },
            { label: "Abgeschlossene Buchungen", icon: "isax-calendar-2", colorClass: "text-purple" },
            { label: "Kunden weltweit", icon: "isax-tag-user5", colorClass: "text-pink" },
            { label: "Registrierte Anbieter", icon: "isax-status-up5", colorClass: "text-info" },
        ],
        expertSection: {
            popularTitle: "Beliebt",
            popularSubtitle: "Entdecken Sie die beliebtesten, am besten bewerteten und am häufigsten von Reisenden gebuchten Dienstleistungen.",
            serviceName: "Tuk Tuk Fahrer",
            loading: "Lädt...",
            reservationsSingular: "Buchung",
            reservationsPlural: "Buchungen",
            viewProfile: "Profil ansehen",
            viewAll: "Alle ansehen",
        },
        driverModal: {
            loading: "Lädt...",
            description: "Beschreibung",
            languages: "Sprachen",
            vehicle: "Fahrzeug",
            seats: "Sitzplätze",
            averageRating: "Durchschnittliche Bewertung",
            reviews: "Bewertungen",
            packages: "Pakete",
            noReviews: "Noch keine Bewertungen",
            noPackages: "Dieser Fahrer hat keine registrierten Pakete"
        },
        testimonialSection: {
            title: "Was unsere {{highlight}} sagen",
            highlight: "Benutzer",
            subtitle: "Sehen Sie, was unsere Reisenden über ihre Erfahrungen dachten.",
            loading: "Bewertungen werden geladen...",
            noReviews: "Keine Bewertungen gefunden.",
            noComment: "Der Benutzer hat keinen Kommentar hinterlassen.",
            viewPackage: "Paketdetails anzeigen"
        },
        updateSection: {
            faq: {
                title: "Häufig",
                highlight: "gestellte Fragen",
                subtitle: "Portugalway, ein auf Traumziele spezialisierter Reiseveranstalter, bietet Reisenden eine Vielzahl von Vorteilen.",
                questions: [
                    {
                        question: "Wie buche ich eine Tour?",
                        answer: "Sie können direkt über unsere Website buchen oder uns per E-Mail oder Telefon kontaktieren. Nach Festlegung der gewünschten Reiseroute erstellen wir ein Angebot, bestätigen Hotels und Dienstleistungen und fordern die Zahlung gemäß der angegebenen Richtlinie an."
                    },
                    {
                        question: "Ist es möglich, die Reiseroute anzupassen?",
                        answer: "Ja! Alle unsere Reiserouten sind flexibel. Sie wählen die Orte, die Sie besuchen möchten, die Dauer, die Art der Unterkunft und, innerhalb der Möglichkeiten, erstellen wir etwas, das zu Ihrem Profil passt."
                    },
                    {
                        question: "Welche Sprachen sprechen die Guides?",
                        answer: "Wir haben Guides, die Portugiesisch, Englisch und, je nach Tour, andere Sprachen sprechen. Bitte geben Sie Ihre Präferenzen bei der Buchung an, damit wir den am besten geeigneten Guide zuweisen können."
                    },
                    {
                        question: "Wie ist die Stornierungsrichtlinie?",
                        answer: "Wir haben eine Stornierungsrichtlinie, die je nach Tour, Vorlaufzeit und Anbietern variiert. Zum Zeitpunkt der Buchung senden wir Ihnen die vollständigen Bedingungen zu. Wir bitten Sie, diese vor der Bestätigung sorgfältig zu lesen."
                    },
                    {
                        question: "Welche Zahlungsmethoden werden akzeptiert?",
                        answer: "Wir akzeptieren internationale Banküberweisung, Kreditkarte und in einigen Fällen andere Zahlungsmethoden."
                    }
                ],
                contactUsText: "Wenn Sie die Antwort auf Ihre Frage in unseren häufig gestellten Fragen nicht finden, kontaktieren Sie uns bitte. Wir werden uns in Kürze bei Ihnen melden!",
                contactButton: "Kontaktieren Sie uns",
            },
            support: {
                items: [
                    "Personalisierte Reiserouten",
                    "Umfassende Planung",
                    "Expertenberatung",
                    "Lokale Erfahrung",
                    "Kundenbetreuung",
                    "Nachhaltigkeitsbemühungen",
                    "Mehrere Regionen"
                ]
            }
        }
    },
    footer: {
        pages: {
            title: "Seiten",
            settings: "Einstellungen",
            profile: "Profil",
            social: "Soziales Netzwerk",
        },
        company: {
            title: "Unternehmen",
            about: "Über Uns",
            testimonials: "Referenzen",
            faq: "Häufig gestellte Fragen",
        },
        support: {
            title: "Support",
            contact: "Kontakt",
            privacy: "Datenschutzbestimmungen",
            terms: "Allgemeine Geschäftsbedingungen",
            chat: "Chat-Support",
        },
        services: {
            title: "Dienstleistungen",
            tuktuk: "Tuk Tuk",
            winery: "Weingut",
            restaurant: "Restaurant",
            car: "Auto",
            hippotrip: "Hippotrip",
            bike: "Fahrrad",
        },
        bottom: {
            copyright: "Copyright © 2025. Alle Rechte vorbehalten,",
            brand: "Portugalwaytour",
            social: [
                { icon: "fa-brands fa-facebook", link: "#" },
                { icon: "fa-brands fa-x-twitter", link: "#" },
                { icon: "fa-brands fa-instagram", link: "#" },
                { icon: "fa-brands fa-linkedin", link: "#" },
                { icon: "fa-brands fa-pinterest", link: "#" },
            ],
            cards: [
                "assets/img/icons/card-01.svg",
                "assets/img/icons/card-02.svg",
                "assets/img/icons/card-03.svg",
                "assets/img/icons/card-04.svg",
                "assets/img/icons/card-05.svg",
                "assets/img/icons/card-06.svg",
            ],
        },
    },

    auth: {
        registerModal: {
            title: "Greifen Sie auf Ihr Konto zu",
            subtitle: "Geben Sie Ihre E-Mail-Adresse ein, um sich anzumelden oder ein Konto zu erstellen",
            emailLabel: "E-Mail",
            emailPlaceholder: "Geben Sie Ihre E-Mail-Adresse ein",
            sendTestCode: "Testcode senden",
            sendEmailCode: "Code per E-Mail senden",
            codeLabel: "Verifizierungscode",
            codePlaceholder: "Geben Sie den Code ein",
            verifyAndLogin: "Verifizieren und Anmelden",
            testCodeSuccess: "Testcode '123456' generiert. Für die Anmeldung verwenden.",
            testCodeError: "Fehler beim Generieren des Testcodes.",
            emailSent: "Code an Ihre E-Mail gesendet!",
            emailError: "Fehler beim Senden des Codes per E-Mail.",
            loginSuccess: "Anmeldung erfolgreich!",
            invalidCode: "Ungültiger oder abgelaufener Code.",
            or: "Oder",
            google: "Google",
            facebook: "Facebook",
            reminderTitle: "Vervollständigen Sie Ihr Profil",
            reminderText: "Vergessen Sie nicht, Ihr Profil zu vervollständigen, um alle Funktionen der Plattform nutzen zu können!",
            gotIt: "Verstanden",
        },
    },
    companyRegisterModal: {
        title: "Firmenregistrierung",
        step1: "Bitte geben Sie Ihre persönliche E-Mail-Adresse ein, um ein Firmenadministratorkonto zu erstellen. Sie werden dieses Konto verwenden, um das Firmenprofil zu verwalten.",
        step2: "Wir haben einen Verifizierungscode an Ihre E-Mail gesendet. Bitte geben Sie ihn unten ein, um Ihre Identität zu überprüfen.",
        step3: "Füllen Sie nun Ihre Unternehmensdaten aus. Die Firmen-E-Mail muss eine Unternehmens-Kontakt-E-Mail sein (z.B. info@firma.com).",

        personalEmail: "Ihre persönliche E-Mail",
        sendTestCode: "Testcode senden",
        sendEmailCode: "Code per E-Mail senden",

        verificationCode: "Verifizierungscode",
        verifyCode: "Code verifizieren",

        companyEmail: "Firmen-E-Mail",
        companyName: "Firmenname",
        nif: "NIF (Steuernummer)",
        nib: "NIB (Bankidentifikationsnummer)",
        permanentCertificate: "Nummer des Dauerzertifikats",
        phone: "Telefon",
        street: "Straße",
        city: "Stadt",
        postalCode: "Postleitzahl",
        country: "Land",
        companyDescription: "Kurze Unternehmensbeschreibung",
        servicesProvided: "Angebotene Dienstleistungen",

        contractTitle: "Firmenvertrag",
        acceptContract: "Ich akzeptiere den Firmenvertrag",
        finishRegistration: "Registrierung abschließen",

        messages: {
            "Test code sent successfully. Use '123456'.": "Testcode erfolgreich gesendet. Verwenden Sie '123456'.",
            "Verification email sent successfully.": "Verifizierungs-E-Mail erfolgreich gesendet.",
            "Verification successful.": "Verifizierung erfolgreich.",
            "Company registered and contract accepted successfully!": "Unternehmen erfolgreich registriert und Vertrag akzeptiert!",
            testStepMessage: "Testcode erfolgreich gesendet. Verwenden Sie '123456'.",
            emailStepMessage: "Ein Verifizierungscode wurde an Ihre E-Mail gesendet. Bitte geben Sie ihn unten ein."
        },

        errors: {
            "Failed to send the verification code.": "Fehler beim Senden des Verifizierungscodes.",
            "Invalid or expired code.": "Ungültiger oder abgelaufener Code.",
            "Please fill all required fields.": "Bitte füllen Sie alle erforderlichen Felder aus.",
            "You must accept the contract to register the company.": "Sie müssen den Vertrag akzeptieren, um das Unternehmen zu registrieren.",
            "You must be logged in to register the company.": "Sie müssen angemeldet sein, um das Unternehmen zu registrieren.",
            "Failed to register the company or accept the contract.": "Fehler bei der Registrierung des Unternehmens oder der Annahme des Vertrags."
        }
    },
    chooseUsSection: {
        title: "Warum uns wählen?",
        cards: [
            {
                title: "Bequemlichkeit",
                description: "Planen Sie Ihre gesamte Reise von einer einzigen Plattform aus, sparen Sie Zeit und Mühe. Kein Wechseln mehr zwischen verschiedenen Websites."
            },
            {
                title: "Bestpreisgarantie",
                description: "Wir arbeiten mit vertrauenswürdigen Reisepartnern zusammen, um Ihnen die besten Angebote zu unterbreiten, sei es für einen Flug, ein Hotel oder einen Mietwagen."
            },
            {
                title: "Kundendienst",
                description: "Unser engagiertes Support-Team steht Ihnen 24/7 zur Verfügung, um sicherzustellen, dass Ihre Reisepläne von Anfang bis Ende reibungslos verlaufen."
            },
            {
                title: "Personalisierte Reiseerlebnisse",
                description: "Egal, ob Sie geschäftlich unterwegs sind, einen Familienurlaub oder ein Solo-Abenteuer planen, wir bieten Optionen, die allen Bedürfnissen gerecht werden."
            }
        ]
    },

    contactUsSection: {
        breadcrumb: {
            home: "Startseite",
            pages: "Seiten",
            contactUs: "Kontakt"
        },
        title: "Kontaktieren Sie unser engagiertes Support-Team",
        description: "Unser Team ist bereit zu helfen. Ihre Zufriedenheit ist unsere Priorität.",
        info: [
            {
                label: "E-Mail-Adresse",
                value: "portugaltourway@gmail.com"
            },
            {
                label: "Telefonnummer",
                value: "NUMMER EINFÜGEN"
            },
            {
                label: "Unser Standort",
                value: "STRASSE EINFÜGEN, Almada - Portugal"
            }
        ],
        supportCard: {
            title: "Brauchen Sie Unterstützung?",
            textLoggedOut: "Um unser Support-Team zu kontaktieren und Tickets zu eröffnen, müssen Sie ein Konto erstellen oder sich anmelden. Danach haben Sie vollen Zugriff auf Ihr Support-Dashboard, wo Sie Ihre Anfragen verfolgen und verwalten können.",
            textLoggedIn: "Sie sind bereits angemeldet! Jetzt können Sie ein neues Support-Ticket öffnen oder bestehende Tickets direkt in Ihrem Dashboard verfolgen.",
            btnLoggedOut: "Konto erstellen / Anmelden",
            btnLoggedIn: "Ticket im Dashboard öffnen"
        }
    },

    sidebar: {
        main: "Hauptmenü",
        dashboard: "Dashboard",
        myBookings: "Meine Buchungen",
        myReviews: "Meine Bewertungen",
        wishlist: "Wunschliste",
        support: "Support",
        finance: "Finanzen",
        wallet: "Brieftasche",
        payments: "Zahlungen",
        account: "Konto",
        myProfile: "Mein Profil",
        notifications: "Benachrichtigungen",
        settings: "Einstellungen",
        preferences: "Einstellungen",
        logout: "Abmelden",
    },

    agentSidebar: {
        dashboard: "Dashboard",
        bookings: "Buchungen",
        tukTukBookings: "Tuk Tuk Buchungen",
        hotelBookings: "Hotelbuchungen",
        carBookings: "Autobuchungen",
        cruiseBookings: "Kreuzfahrtbuchungen",
        tourBookings: "Tourbuchungen",
        flightBookings: "Flugbuchungen",
        enquiries: "Anfragen",
        earnings: "Einnahmen",
        reviews: "Bewertungen",
        support: "Support",
        serviceEnrollment: "Dienstleistungsregistrierung",
        drivers: "Fahrer",
        tukTukVehicles: "Tuk Tuk Fahrzeuge",
        settings: "Einstellungen",
        logout: "Abmelden",
    },

    dashboardCards: {
        totalBookings: "Gesamtzahl gekaufter Pakete",
        totalListings: "Gesamtzahl Pakete",
        totalEarnings: "Gesamteinnahmen",
        totalReviews: "Gesamtbewertungen",
    },

    recentlyadded: {
        titulo: "Kürzlich hinzugefügt",
    },

    BookingsStatistics: {
        titulo: "Buchungsstatistiken",
        loading: "Statistiken werden geladen...",
        none: "Noch keine Buchungen registriert.",
    }
};